import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonDescriptionField from '../../../common/fields/DescriptionField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

interface Props {}

const DescriptionField: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <CommonDescriptionField
      fieldName={ArtsAndCraftsDeviationFieldName.DESCRIPTION}
      label={t('artsAndCraftsDeviationPopup.form.description.label')}
      placeholder={t('artsAndCraftsDeviationPopup.form.description.placeholder')}
    />
  );
};
DescriptionField.displayName = 'DescriptionField';

export default DescriptionField;
